// @flow

import React from 'react';
import { observer } from 'mobx-react';
import debounce from 'lodash/debounce';
import FontAwesome from 'react-fontawesome';
import { css } from 'glamor';
import { InputGroup, FormControl } from 'react-bootstrap';

const inputRule = css({
    height: '35px',

    '&:hover': {
        outline: 'none',
        borderColor: '#b2d9f7',
    },

    '&:focus': {
        borderColor: '#b2d9f7',
    },

    '&::placeholder': {
        fontWeight: 300,
    },
});

const iconRule = css({
    color: '#fff',
    backgroundColor: 'rgb(228, 65, 34)',
    border: '1px solid rgb(228, 65, 34)',
});

@observer
export default class SearchInput extends React.Component {
    props: {
        callback: () => void,
        placeholder: string,
        icon: boolean,
    };

    delayedCallback: () => void;

    constructor() {
        super();
    }

    componentWillMount() {
        this.delayedCallback = debounce(event => {
            this.props.callback(event.target.value);
        }, 500);
    }

    handleChange(event: Object) {
        event.persist();
        this.delayedCallback(event);
    }

    render() {
        const { icon } = this.props;
        const Icon = icon ?
            (<InputGroup.Addon { ...iconRule }>
                  <FontAwesome name="search" />
              </InputGroup.Addon>) :
            null;

        return (
            <InputGroup>
                <FormControl
                    { ...inputRule }
                    type="text"
                    placeholder={ this.props.placeholder }
                    onChange={ this.handleChange.bind(this) }
                />
                {Icon}
            </InputGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/SearchInput/index.js